import { Directive, ElementRef, HostListener, Input, OnChanges } from '@angular/core';

@Directive({
    selector: '[numbersOnly]'
})
export class NumbersOnlyDirective implements OnChanges {

    @Input() numbersOnly: any;

    constructor(private el: ElementRef) { }

    @HostListener('keydown', ['$event'])
    keyDownEvent(event: KeyboardEvent) {

        if (event.key != undefined) {
            if (event.key.length === 1 && (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || (event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 9 || event.keyCode == 17 || event.keyCode == 91 || event.keyCode == 86 || event.keyCode == 67)) {
                // 0-9 only
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }

    ngOnChanges(changes) {
        if (changes.numbersOnly) {
            this.el.nativeElement.value = this.el.nativeElement.value.replace(/[^0-9]/g, '');
        }
    }

}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Directives/NumbersOnlyDirective .ts